/**
 * Create the store with dynamic reducers
 */

/**
 * Create the store with dynamic reducers
 */
import { combineReducers, configureStore } from '@reduxjs/toolkit';
import { createInjectorsEnhancer } from 'redux-injectors';
import createSagaMiddleware from 'redux-saga';
import { createBrowserHistory } from 'history';
import logger from 'redux-logger';
import { createReduxHistoryContext } from 'redux-first-history';
import { enableES5 } from 'immer';
import { PROD } from 'utils/constants';
import globalSaga from './saga';

export const basename = process.env.PUBLIC_PATH;

// Immer 10+ removed ES5 mode; local `file:` Cashmere can hoist Recharts → RTK2 → Immer 11, and
// Module Federation `immer` singleton may resolve that build for this import.
if (typeof enableES5 === 'function') {
  enableES5();
}

export const {
  createReduxHistory,
  routerMiddleware,
  routerReducer,
} = createReduxHistoryContext({
  history: createBrowserHistory({
    basename,
  }),
});
/**
 * Merges the main reducer with the router state and dynamically injected reducers
 */
export function createReducer(injectedReducers = {}) {
  const rootReducer = combineReducers({
    ...injectedReducers,
    router: routerReducer,
  });

  return rootReducer;
}

const reduxSagaMonitorOptions = {};
const sagaMiddleware = createSagaMiddleware(reduxSagaMonitorOptions);
const { run: runSaga } = sagaMiddleware;

const envObj = process.env;
const isProd = envObj.NODE_ENV === PROD;

// Create the store with two middlewares
// 1. sagaMiddleware: Makes redux-sagas work
// 2. routerMiddleware: Syncs the location/URL path to the state
const middlewares = [
  sagaMiddleware,
  routerMiddleware,
  ...(!isProd ? [logger] : []),
];

const injectorsEnhancer = createInjectorsEnhancer({
  createReducer,
  runSaga,
});

export const store = configureStore({
  reducer: createReducer(),
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({
      serializableCheck: false,
    }).concat(middlewares),
  devTools: !isProd,
  // RTK 2+ requires a callback here; an array only works on RTK 1. Hoisted RTK (e.g. via
  // symlinked Cashmere → Recharts) can be v2, so always use the callback form.
  enhancers: defaultEnhancers =>
    defaultEnhancers.concat(injectorsEnhancer),
});

sagaMiddleware.run(globalSaga);

export const history = createReduxHistory(store);
